import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'projectType'
})
export class ProjectTypePipe implements PipeTransform {

    transform(value: string, ...args: unknown[]): string {
        switch (value) {
            case 'investment':
                return 'Investitionsprojekt';
            case 'expenses':
                return 'Aufwandprojekt';
            default:
                return value;
        }
    }

}
